import {
  defaultLoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import React, { createContext } from 'react';
import type { RecommendedVehicle } from '~/contracts/common';

const defaultContext = defaultLoadableState<RecommendedVehicle[]>([]);

export type ContextType = typeof defaultContext;

const VehiclesAvailableSoonerContext =
  createContext<ContextType>(defaultContext);

export function VehiclesAvailableSoonerContextProvider({
  children
}: React.PropsWithChildren) {
  const vehicles = useLoadableState<RecommendedVehicle[]>([]);

  return (
    <VehiclesAvailableSoonerContext.Provider value={vehicles}>
      {children}
    </VehiclesAvailableSoonerContext.Provider>
  );
}

VehiclesAvailableSoonerContextProvider.displayName =
  'VehiclesAvailableSoonerContextProvider';

export default VehiclesAvailableSoonerContext;
